import React from "react";
import Commonfooter from "../../UI/FooterCommon/Commonfooter";

import "./Footer.css";
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";

/**
 * @desc Footer section for recruiter
 * @version 1.0.1
 * @author Amrutha, Praveen George
 */

const Footer = () => {
  return (
    <div className="admin-footer-main">
      <div className="admin-footer-text">
        <Commonfooter />
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Admin/Footer/Footer.js